module.exports = __webpack_public_path__ + "img/avatar-1.055c60a1.png";